export interface RouteMetaAuth {
	checkAuth?: boolean
	authRedirect?: string
	auth?: boolean
	roles?: RouteMetaAuthRole | RouteMetaAuthRole[]
}

export enum RouteRole {
	ALL = "ALL"
}

export enum UserRole {
	DOCTOR = "DOCTOR",
	PATIENT = "PATIENT",
	SECRETARY = "SECRETARY"
}

export type RouteMetaAuthRole = UserRole | RouteRole

export interface AppUser {
	access_token: string
	medical_center: number
	role: UserRole
	username: string
	picture: string
	validated: boolean
	created_at: Date
}

export interface VerifyEmailResponse {
	email: string
	name?: string
	surname?: string
	phone?: string
	lang: string
	doctor?: {
		name: string
		surname: string
	}
}

export type OtpRequestMethods = "SMS" | "EMAIL"
export type OtpValidateMethods = "SMS" | "EMAIL" | "TOTP"

export interface TotpConfig {
	secret: string
	url: string
}

export interface OtpValidationResponse {
	temp_auth_token: string
}
